@if (message.body !== '<p><br></p>') {
  <div
    class="message text-grey-600 pointer-none m-auto p-2 mt-2.5 -mb-2.5 text-center"
    [innerHTML]="message?.body"
  ></div>
}
